import React from 'react';

export type AlertVariant = 'info' | 'success' | 'warning' | 'danger';

export interface AlertProps {
  variant?: AlertVariant;
  title?: string;
  children?: React.ReactNode;
  linkText?: string;
  linkHref?: string;
  className?: string;
  onClose?: () => void;
}

/**
 * KERN Alert Component
 *
 * Usage:
 * <Alert variant="info" title="Information">Optional description text</Alert>
 * <Alert variant="danger" title="Fehler" linkText="Mehr erfahren" linkHref="/help" />
 * <Alert variant="warning" onClose={() => dismiss()}>Dismissable alert</Alert>
 */
export function Alert({
  variant = 'info',
  title,
  children,
  linkText,
  linkHref,
  className = '',
  onClose,
}: AlertProps) {
  const classes = ['kern-alert', `kern-alert--${variant}`, className].filter(Boolean).join(' ');

  return (
    <div className={classes} role="alert">
      <div className="kern-alert__header">
        <span className={`kern-icon kern-icon--${variant}`} aria-hidden="true" />
        {title && <span className="kern-title">{title}</span>}
        {!title && children && <span className="kern-body">{children}</span>}
        {onClose && (
          <button
            type="button"
            className="kern-alert__close kern-btn kern-btn--tertiary"
            onClick={onClose}
            aria-label="Schließen"
          >
            <span className="kern-icon kern-icon--close" aria-hidden="true" />
          </button>
        )}
      </div>
      {title && (children || linkText) && (
        <div className="kern-alert__body">
          {children && <p className="kern-body">{children}</p>}
          {linkText && linkHref && (
            <a href={linkHref} className="kern-link">
              <span className="kern-icon kern-icon--arrow-forward" aria-hidden="true" />
              {linkText}
            </a>
          )}
        </div>
      )}
    </div>
  );
}

export default Alert;
